<section class="event-upload-card" aria-label="event data upload controls">
  <div class="upload-title-wrap">
    <h3 class="upload-title">Event Admin</h3>
    <p class="upload-subtitle">Upload a new sheet for the selected event. Existing rows for that event will be replaced.</p>
  </div>

  @if (!selectedEvent) {
  <div class="event-selector-wrap">
    <label class="upload-label" for="event-admin-select">Select Event</label>
    <select id="event-admin-select" class="upload-input" [value]="selectedEventId" (change)="onSelectedEventChange($event)">
      <option value="" disabled>Select an event</option>
      @for (event of availableEvents; track event.event_id) {
      <option [value]="event.event_id">{{ event.event_name }}</option>
      }
    </select>
  </div>
  }

  <div class="upload-grid">
    <div class="upload-col">
      <label class="upload-label" for="event-xlsx-input">Excel File</label>
      <input id="event-xlsx-input" class="upload-input" type="file" accept=".xlsx,.xls" (change)="onUploadFileChange($event)" #fileInput>
      <p class="upload-file-name">{{ selectedUploadFile?.name || 'No file selected' }}</p>
    </div>
    <div class="upload-col mapping-col">
      <label class="upload-label" for="event-column-mapping">Column Mapping (JSON)  {{ '---> {' }}"FileColumnName": "db_column_name"{{ '}' }}</label>
      <textarea id="event-column-mapping" class="mapping-input" rows="24" [value]="mappingText"
        (input)="onMappingChanged(mapping.value)" #mapping></textarea>
    </div>
    <div class="upload-action-col">
      <button type="button" class="upload-button" [disabled]="isUploading || !selectedUploadFile"
        (click)="uploadEventSheet()">
        {{ isUploading ? 'Uploading...' : 'Upload and Replace' }}
      </button>
    </div>
  </div>
</section>
